<template>
  <div class="class_dialog">
    <div class="dialog_box">
      <div class="dialog_message">手机浏览器暂不支持查看该课件<br/>你可在"{{appname}}APP"进行查看</div>
      <p><span @click='cancel_flag'>取消</span>
        <span v-if='android' class="goapp">
          <a :href="scheme + '?type=2&sso_id='+sso_id+'&orderSn='+ data.order_id + '&package_id=' + data.package_id + '&cid=' + data.cid + '&menu_id=' + data.menu_id
           + '&spuID=' + data.shopid + '&owner=' + owner + '&channel=' + channel + '&orgn=' + orgn" @click='search_flag'>打开APP
          </a>
        </span>
        <span v-else-if='ios' class="goapp" @click='search_flag'>去APP查看</span>
        <!-- <wx-open-launch-app v-if='ua.match(/MicroMessenger/i) == "micromessenger"&&android'
          id="launch-btn" @error="handleErrorFn" @launch="handleLaunchFn" :appid="appid"
          :extinfo="JSON.stringify({'type': 2, 'sso_id': sso_id,'orderSn': data.order_id, 'package_id': data.package_id, 'cid': data.cid, 'menu_id': data.menu_id, 'spuID': data.shopid, 'owner': owner, 'channel': channel, 'orgn': orgn})"
        >
          <script type="text/wxtag-template">
            <style>.btn { color: #fff; font-size: 10px; text-align:center; line-height:23px}
              </style>
              <div class="btn">去APP查看</div>
          </script>
        </wx-open-launch-app> -->
      </p>
    </div>
    <arouse v-if="arshow" @arouse='receive'></arouse>
  </div>
</template>
<script>

import arouse from '../arouse/index.vue'
export default {
  data() {
    return {
      owner: this.$route.query.owner,
      channel: this.$route.query.channel,
      orgn: this.$route.query.orgn,
      ua: navigator.userAgent.toLowerCase(),
      android: navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1,
      ios: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      sf: '',
      appname: '',
      open_url: '',
      appid: '',
      sso_id: '',
      arshow: false,
      isweixin: false,
      scheme: ''
    }
  },
  components: {
    arouse
  },
  props: ['data'],
  methods: {
    cancel_flag () {
      this.$emit('openapp', 'false')
    },
    handleErrorFn(e) {
      this.arshow = true
      console.log(JSON.stringify(e), '跳转失败')
      Toast("当前手机未下载中公教育app");
      // this.download() // 这里跳转App下载页面
    },
    // 监听launch 函数
    handleLaunchFn(e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    download(){
      if (this.sf == 'sydw') {
        window.location.href ="https://xue.offcn.com/institution/";
      } else if (this.sf == 'zgwx') {
        window.location.href ="https://www.eoffcn.com/help/download/online_course.html";
      } else {
        //判断iPhone|iPad|iPod|iOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          window.location.href ="https://apps.apple.com/cn/app/%E4%B8%AD%E5%85%AC%E6%95%99%E8%82%B2/id735754930";
        } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
          window.location.href ="https://a.app.qq.com/o/simple.jsp?pkgname=com.offcn.android.offcn&channel=0002160650432d595942&fromcase=60001";
        } else {  // PC端
          window.location.href ="https://www.offcn.com/daohang/zgapp/#nub1";
        }
      }
    },
    handleJudgeWechat() {
      const wechatInfo = window.navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
      if (!wechatInfo) return;
      let judgewechat = wechatInfo[1].split(".");
      let flag = false;
      if (judgewechat[0] >= 7) {
        if (judgewechat[1] >= 0) {
          if (judgewechat[2] >= 12) {
            this.wechatState = true;
            flag = true;
          }
        }
      }
      if (!flag) {
        Toast.fail('请升级当前微信版本');
        return false
      }
    },
    openApp (src) {
      var d = new Date()
      var t0 = d.getTime()
      var delay = setInterval(function() {
        var d = new Date();
        var t1 = d.getTime();
        if( t1-t0<3000 && t1-t0>2000) {
          window.location.href = src;
        }
        if (t1 - t0 >= 3000) {
          clearInterval(delay);
        }
      },2000);
    },
    search_flag() {
      if (!this.isweixin) {
        this.arshow = false
        if (this.sf == 'zxkt' || this.sf == 'zgwx') {
          this.openApp('//www.eoffcn.com/help/download/online_course.html')
        } else if (this.sf == 'zgtk') {
          this.openApp('//tiku.eoffcn.com/web/app/scan.html')
        } else if (this.sf == 'sydw') {
          this.openApp('//3min-class.offcn.com/videos/h5/download/institution/')
        } else if (this.sf == 'zgzsb') {
          this.openApp('//www.eoffcn.com/zg_zsb/detail?orderSn=' + this.data.order_id + '&spuID=' + this.data.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' + this.$route.query.orgn)
        } else if (this.sf == 'zgyljy') {
          this.openApp('//www.eoffcn.com/zg_yikao/')
        } else if (this.sf == 'zgky') {
          this.openApp('//www.eoffcn.com/zg_postgraduate/')
        } else if (this.sf == 'zgjsgc') {
          this.openApp('//www.zggcks.com/zg/2021jgapp/')
        } else if (this.sf == 'zgyouzhi') {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            } else {
              SERVER_BASE_URL = 'http://tiku.eoffcn.com/web/app/youzhi_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_youzhi/detail?orderSn=' + this.data.order_id + '&spuID=' + this.data.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' + this.$route.query.orgn
          }
        } else {
          if (this.android) {
            var SERVER_BASE_URL
            if (process.env.NODE_ENV=='production') {
              SERVER_BASE_URL = 'https://zgjyapp.offcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            } else {
              SERVER_BASE_URL = 'http://tiku.t.eoffcn.com/web/app/offcn_uni_scan.html?owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
            }
            this.openApp(SERVER_BASE_URL);
          } else if (this.ios) {
            location.href = 'https://www.eoffcn.com/zg_jiaoyu/detail?orderSn=' + this.data.order_id + '&spuID=' + this.data.shopid + '&owner=' + this.$route.query.owner + '&channel=' + this.$route.query.channel + '&orgn=' +this.$route.query.orgn + '&channelId=225'
          }
        }
      } else {
        this.arshow = true
      }
    },
    receive (val) {
      this.arshow = val
    }
  },
  watch:{
    data: {
      handler(data) {
        console.log(data)
        this.sso_id = localStorage.getItem("ticketObj")?JSON.parse(localStorage.getItem("ticketObj")).sso_id:''
        this.sf = this.$route.query.sf
        if (this.sf == 'zxkt') {
          this.appid = 'wx1062070e19e76b81'
          this.appname = '在线课堂'
          this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
        } else if (this.sf == 'zgwx') {
          this.appid = 'wx1062070e19e76b81'
          this.appname = '中公网校'
          this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
        } else if (this.sf == 'sydw') {
          this.appid = 'wx4161c8d806017e0d'
          this.appname = '事业单位'
          this.open_url = 'https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ data.order_id +'&spuID='+ data.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
        } else if (this.sf == 'zgtk') {
          this.appname = '中公题库'
          this.scheme = 'zhonggongtiku://openapp'
          this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
        } else if (this.sf == 'zgzsb') {
          this.appname = '中公专升本'
          this.open_url = 'https://www.eoffcn.com/zg_zsb/detail?orderSn=' + data.order_id + '&package_id=' + data.package_id + '&cid=' + data.cid + '&menu_id=' + data.menu_id
              + '&spuID=' + data.shopid + '&owner=' + this.owner + '&channel=' + this.channel + '&orgn=' + this.orgn
          this.scheme = 'zhonggongzhuanshengben://openapp'
        } else if (this.sf == 'zgyljy'){
          this.appname = '中公医疗教育'
          this.open_url = 'https://www.eoffcn.com/zg_yikao'
        } else if (this.sf == 'zgjsgc') {
          this.appname = '中公建设工程'
          this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
        } else if (this.sf == 'zgyouzhi') {
          this.appid = 'wx91652b0b55a2ca52'
          this.appname = '优职'
          this.scheme = 'zgyouzhi://openapp'
          this.open_url = 'https://www.eoffcn.com/zg_youzhi/detail?orderSn=' + data.order_id + '&package_id=' + data.package_id + '&cid=' + data.cid + '&menu_id=' + data.menu_id
              + '&spuID=' + data.shopid + '&owner=' + this.owner + '&channel=' + this.channel + '&orgn=' + this.orgn
        } else {
          this.appid = 'wx4a8209bce2ce2a1d'
          this.appname = '中公教育'
          this.scheme = 'zhonggongjiaoyu://openapp'
          console.log(data)
          this.open_url = 'https://www.eoffcn.com/zg_jiaoyu/detail?orderSn=' + data.order_id + '&package_id=' + data.package_id + '&cid=' + data.cid + '&menu_id=' + data.menu_id
              + '&spuID=' + data.shopid + '&owner=' + this.owner + '&channel=' + this.channel + '&orgn=' + this.orgn
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      var btn = document.getElementById('launch-btn')
      btn.addEventListener('launch', function(e) {
        this.handleJudgeWechat(); //是否满足跳转app条件
      });
    })
    this.sf = this.$route.query.sf
    if (this.sf == 'zxkt') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '在线课堂'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'zgwx') {
      this.appid = 'wx1062070e19e76b81'
      this.appname = '中公网校'
      this.open_url = 'https://www.eoffcn.com/wx_classonline/detail'
    } else if (this.sf == 'sydw') {
      this.appid = 'wx4161c8d806017e0d'
      this.appname = '事业单位'
      this.open_url = 'https://3min-class.offcn.mobi/institution/?type=1&sso_id='+this.sso_id+'&orderSn='+ data.order_id +'&spuID='+ data.shopid +'&owner='+this.$route.query.owner+'&channel='+this.$route.query.channel+'&orgn='+this.$route.query.orgn
    } else if (this.sf == 'zgtk') {
      this.appname = '中公题库'
      this.scheme = 'zhonggongtiku://openapp'
      this.open_url = 'https://www.eoffcn.com/zg_questions/detail'
    } else if (this.sf == 'zgzsb') {
      this.appname = '中公专升本'
      this.open_url = 'https://www.eoffcn.com/zg_zsb/detail'
    } else if (this.sf == 'zgyljy') {
      this.appname = '中公医疗教育'
      this.open_url = 'https://www.eoffcn.com/zg_yikao'
    } else if (this.sf == 'zgjsgc') {
      this.appname = '中公建设工程'
      this.open_url = 'https://www.zggcks.com/zg/2021jgapp/'
    } else if (this.sf == 'zgyouzhi') {
      this.appid = 'wx91652b0b55a2ca52'
      this.appname = '优职'
      this.scheme = 'zgyouzhi://openapp'
    } else {
      this.appid = 'wx4a8209bce2ce2a1d'
      this.appname = '中公教育'
      this.scheme = 'zhonggongjiaoyu://openapp'
    }
    //是否是微信浏览器
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      //是否电脑微信或者微信开发者工具
      if(/(WindowsWechat)/i.test(navigator.userAgent) || /(wechatdevtools)/i.test(navigator.userAgent)){
        console.log('电脑微信或者微信开发者工具')
        this.isweixin = false;
      }else{
        //手机微信打开的浏览器
        console.log('手机微信')
        this.isweixin = true;
      }
    } else {
      console.log('其他浏览器')
      this.isweixin = false;
    }
  }
};
</script>
<style lang="less" scoped>
.class_dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, .6);
  z-index: 2;
  .dialog_box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 490px;
    line-height: 40px;
    border-radius: 18px;
    transform: translate(-50%, -50%);
    background: #fff;
    .dialog_message {
      text-align: center;
      padding: 30px 30px;
    }
    p {
      display: flex;
      border-top: 1px solid #e5e5e5;
      height: 70px;
      line-height: 70px;
      span {
        flex: 1;
        text-align: center;
      }
      .goapp {
        border-left: 1px solid #e5e5e5;
        a {
          color: #e60012;
        }
      }
    }
  }
  .sf {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/goapp.vue